export default __webpack_public_path__ + "163f3a8fc50e5707f15245804911550d.png";